// extracted by css-extract-rspack-plugin
export default {"kibScope":"kibScope-iiiBHs","hideArrow":"hideArrow-u0WikW","customDropdown":"customDropdown-CxW8pE"};